const sizes = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
};

// eslint-disable-next-line import/prefer-default-export
export const devices = {
  sm: `(min-width: ${sizes.sm})`,
  md: `(min-width: ${sizes.md})`,
  lg: `(min-width: ${sizes.lg})`,
  xl: `(min-width: ${sizes.xl})`,
};

export const screen = {
  sm: `(max-width: ${sizes.sm})`,
  md: `(max-width: ${sizes.md})`,
  lg: `(max-width: ${sizes.lg})`,
  xl: `(max-width: ${sizes.xl})`,
};
